module.exports = __webpack_public_path__ + "images/menu_new2d4ed7cb4246948b6e752c12f8e02a42.svg";